import { useState } from "react";

function AdvancedOptionsFuturesModule() {
  const [openModule, setOpenModule] = useState(null);

  const toggleModule = (index) => {
    setOpenModule(openModule === index ? null : index);
  };

  const modules = [
    {
      title: "Module 1: Understanding Options and Futures Market Dynamics",
      content: [
        "The interrelationship between options and futures markets.",
        "Analyzing market sentiment through futures and options data.",
        "Impact of macroeconomic factors (interest rates, inflation, geopolitical events) on options and futures pricing.",
        "Advanced understanding of margin requirements, leverage, and position sizing.",
      ],
    },
    {
      title: "Module 2: Advanced Options Strategies",
      content: [
        "Iron Condors and Adjustments: Optimizing iron condors for high probability trades.",
        "Butterfly Variations: Broken Wing Butterfly, Unbalanced Butterfly, and Iron Butterfly strategies.",
        "Calendar and Diagonal Spreads: Utilizing time decay and volatility shifts.",
        "Ratio Spreads and Backspreads: High-reward strategies for directional moves.",
      ],
    },
    {
      title: "Module 3: Futures Trading Strategies",
      content: [
        "Trend Following and Mean Reversion: Using moving averages, Bollinger Bands, and momentum indicators.",
        "Spread Trading: Calendar spreads, inter-commodity spreads, and crack spreads.",
        "Scalping and Day Trading Techniques: Leveraging short-term market movements for quick profits.",
        "Seasonal Futures Trading: Identifying seasonal patterns in commodities, indices, and currencies.",
      ],
    },
    {
      title: "Module 4: Delta Neutral Trading",
      content: [
        "Understanding Delta neutral strategies for hedging and speculation.",
        "Delta Hedging: Creating neutral positions using options and futures.",
        "Building Delta neutral portfolios using combinations of options and futures.",
        "Real-life examples of managing Delta neutral trades in volatile markets.",
      ],
    },
    {
      title: "Module 5: Options Volatility Trading",
      content: [
        "Volatility Arbitrage: Capitalizing on discrepancies between implied and historical volatility.",
        "Trading strategies focused on the Volatility Index (VIX) and volatility ETFs.",
        "Advanced volatility strategies: Long and short gamma trading, Vega scalping.",
        "Using volatility surfaces (Volatility Smile and Skew) for predictive analysis.",
      ],
    },
    {
      title: "Module 6: Futures Options Strategies",
      content: [
        "Utilizing options on futures for leveraged exposure.",
        "Covered Calls and Protective Puts on Futures: Enhancing returns and reducing risk.",
        "Advanced Futures Options strategies: Ratio spreads, strangles, and butterflies.",
        "Using futures options for hedging commodity and currency risk.",
      ],
    },
    {
      title: "Module 7: Inter-Market Analysis and Correlations",
      content: [
        "Understanding correlations between stocks, bonds, commodities, and currencies.",
        "Analyzing inter-market signals for options and futures trading.",
        "Using correlation matrices and heat maps to identify trading opportunities.",
        "Real-world examples of inter-market analysis driving trade decisions.",
      ],
    },
    {
      title: "Module 8: Advanced Risk Management Techniques",
      content: [
        "Value at Risk (VaR): Measuring and managing risk exposure.",
        "Using options and futures to hedge portfolio risk.",
        "Advanced stop-loss strategies and position adjustments.",
        "Psychological aspects of trading: Developing discipline and managing emotions.",
      ],
    },
    {
      title: "Module 9: Algorithmic Trading with Options and Futures",
      content: [
        "Basics of algorithmic trading: Developing automated strategies.",
        "Building custom options and futures trading algorithms using Python.",
        "Backtesting and optimizing strategies using historical data.",
        "Overview of automated trading platforms and API integration.",
      ],
    },
    {
      title: "Module 10: Event-Driven and News-Based Trading",
      content: [
        "Trading options and futures around earnings, economic reports, and geopolitical events.",
        "Pre- and Post-Event Volatility Strategies: Straddles, strangles, and spreads.",
        "Using futures for event-driven strategies (e.g., Non-Farm Payrolls, Fed meetings).",
        "Managing risk during high-impact news events.",
      ],
    },
    {
      title: "Module 11: Real-Time Market Analysis and Case Studies",
      content: [
        "Live options and futures trading examples with market analysis.",
        "Step-by-step breakdown of successful trades, including entry, adjustment, and exit strategies.",
        "Interactive Q&A sessions with live market analysis and trading simulations.",
        "Developing a personalized trading plan and adapting it to different market conditions.",
      ],
    },
  ];

  return (
    <div className="container-fluid">
      <div className="container py-5">
        <h1 className="text-center mb-5">Advanced Options and Futures Trading</h1>
        <div className="row justify-content-center">
          {modules.map((module, index) => (
            <div key={index} className="col-12 col-md-5 mb-3">
              {/* Module Header */}
              <div
                className="p-3 d-flex justify-content-between align-items-center"
                style={{
                  background: "#e9ecef",
                  border: "1px solid #ced4da",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                onClick={() => toggleModule(index)}
              >
                <h5 className="m-0">{module.title}</h5>
                <span
                  style={{
                    fontSize: "18px",
                    transform: openModule === index ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                  }}
                >
                  ▼
                </span>
              </div>

              {/* Module Content */}
              {openModule === index && (
                <div
                  className="p-3 mt-2"
                  style={{
                    background: "#ffffff",
                    border: "1px solid #ced4da",
                    borderRadius: "5px",
                  }}
                >
                  {module.content.map((item, i) => (
                    <p key={i} style={{ fontSize: "14px", margin: "5px 0" }}>
                      ➤ {item}
                    </p>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default AdvancedOptionsFuturesModule;
